import { useEffect, useMemo, useState } from "react";
import { _AdquisitionContractModify, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { BasicTable, MASK_DATE, MASK_MONEY } from "../../../theme/Component/BasicTable";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Modal } from "../../../theme/Component/Modal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { InputDate } from "../../../theme/Input/InputDate";
import { RPsEditor } from "../../../contabilidad/budgetObligationFactory/RPsEditor";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { SelectContractModifyType } from "../../../erp/ContractModifyType/SelectContractModifyType";
import { toast } from "react-toastify";

interface Props {
    contract: any;
}


export const AdquisitionContracModify = ({ contract }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AdquisitionContractModify);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const head = [
        { title: 'ID', property: 'IDAdquisitionContractModify', visible: false },
        { title: 'Valor', property: 'AmountModify', visible: true, mask: MASK_MONEY },
        { title: 'Modificación', property: 'NameModify', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Mnemonico', property: 'RPMnemonic', visible: false },
        { title: 'Consecutivo', property: 'RPConsecutive', visible: false },
        { title: 'Fecha Final', property: 'UptoDate', visible: true, mask: MASK_DATE },
        { title: 'Modificado', property: 'Since', visible: true, mask: MASK_DATE },
        { title: 'Funcionario', property: 'EntityEmploye', visible: true },
    ]

    useEffect(() => {
        if (contract.IDAdquisitionContract) {
            getLista()
        }
    }, [contract])

    const getLista = () => {
        instance.getAdquisitionContractModifyRender(contract.IDAdquisitionContract).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { console.log(err) })
    }

    const updateItem = () => {
        instance.updateAdquisitionContractModify(bean).then(
            (resp) => {
                setModal({ ...modal, "view": false });
                getLista();
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const create = () => {
        setBean({
            IDAdquisitionContract: contract.IDAdquisitionContract,
            IDEmployee: _single.getAccountID(),
            ModifyBudget: false,
            State: 1,

        });
        setModal({ ...modal, "view": true, "name": "Agregar Modificación Contractual" })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { create() } }
    ]

    const elimiarItem = () => {
        bean.State = 2;
        updateItem();
        setModalC({ ...modalC, 'view': false });
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Modificación Contractual" }) } },
            { titulo: 'Eliminar', icono: 'ri-eraser-fill', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": "Eliminar Modificación Contractual" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        if (bean.ModifyBudget === false) {
            setBean({ ...bean, "RPMnemonic": null, "RPConsecutive": null, "RPCurrency": null })
        }
    }, [bean.ModifyBudget])

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            updateItem();
        }
    }

    const validateForm = () => {
        const requiredFields = ["UptoDate", "ModifyType"];
        let missing = [];

        for (let field of requiredFields) {
            if (!bean[field]) {
                missing.push(field);
            }
        }

        // if (bean.ModifyBudget) {
        //     if (!bean.RPConsecutive) {
        //         missing.push("RPConsecutive");
        //     }
        //     if (!bean.AmountModify || bean.AmountModify <= 0) {
        //         missing.push("AmountModify");
        //     }
        // }

        setMissingFields(missing);

        return missing.length;
    };

    const memoizedMissingFields = useMemo(() => missingFields, [missingFields]);

    return (
        <div className="row">
            {/* <PrintJson json={contract} /> */}
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData} >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${memoizedMissingFields.includes("UptoDate") ? "has-error" : ""}`}>Fecha de Finalización</label>
                            <InputDate name="" value={bean.UptoDate} setDate={(e) => setBean({ ...bean, "UptoDate": e })} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${memoizedMissingFields.includes("ModifyType") ? "has-error" : ""}`}>Tipo de Modificación</label>
                            <SelectContractModifyType label=" " idSelector={bean.ModifyType} onChange={(e) => setBean({ ...bean, "ModifyType": e })} />
                        </div>

                        <div className="col-md-12">
                            <BasicSwitch estado={bean.ModifyBudget} eventChange={(e) => setBean({ ...bean, "ModifyBudget": e })} label="¿Modifica Presupuesto?" />
                        </div>

                        {bean.ModifyBudget && (
                            <>
                                <div className="col-md-6">
                                    <label className={`${memoizedMissingFields.includes("RPConsecutive") ? "has-error" : ""}`}>Cuenta Asociada</label>
                                    <RPsEditor label=" " _idAccount={contract.IDAccount} onChange={(e) => setBean({ ...bean, "RPMnemonic": e.Mnemonic, "RPConsecutive": e.Consecutive, "AmountModify": e.Value })} />
                                </div>

                                <div className="col-md-6">
                                    <label className={`${memoizedMissingFields.includes("AmountModify") ? "has-error" : ""}`}>Valor</label>
                                    <InputMoney _label=" " _value={bean.AmountModify} onChange={(e) => setBean({ ...bean, "AmountModify": e })} />
                                </div>
                            </>
                        )}

                        <div className="col-md-12">
                            <label> Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => setBean({ ...bean, "Description": e.target.value })} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalC} updateModal={setModalC} eventModal={elimiarItem}>
                    <strong>Eliminar registro</strong>
                </Modal>
            </div>

        </div>
    )
}